<template>
  
  <ion-page id="verbalplay-page">
    <ion-content>

      <div v-if="showState == SHOW_EXPLAINTOUR">
        <ExplainTour :screen="explainTourScreen"
                      :wordsSpoken="explainTourWordsSpoken"
                      :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                    @toolbar-click="explainTourToolbarClick" />

      </div>

      <div v-if="showState == SHOW_MULTIPLE_OPTIONS">
        <MultiOptions :displayArray="multipleOptionsArray"
                        :wordsSpoken="multiOptionsWordsSpoken"
                        :wordsSpokenTrigger="multiOptionsWordsSpokenTrigger"
                        @item-selected="multiOptionsClick"
                        @toolbar-click="multiOptionsToolbarClick" />
      </div>

      <div v-if="showState == SHOW_SINGLE_OPTION">
        <SingleOption :displayArray="singleOptionArray"
                        :descriptionHeading="singleOptionHeading"
                        :initialSelected="singleOptionSelected"
                        :wordsSpoken="singleOptionWordsSpoken"
                        :wordsSpokenTrigger="singleOptionWordsSpokenTrigger"

                        @item-selected="singleOptionClick" 
                        @toolbar-click="singleOptionToolbarClick"/>
      </div>

      <div v-show="showState == SHOW_PLAY" >
        <TopLine :style="styleTopline"  :title="playTitle" :microphoneIsMuted="microphoneIsMuted" 
                      @topline-click="toplineClick"/>
        <div :style="styleMiddle">

          <div id="the-board"  :style="styleBoard">
              <CMChessboard :fen="forceFen" :validMoves="availableMoves" 
                        :orientation="orientation" 
                        :boardSize="boardSize" 
                        :animateOnePly="animateFen"
                        :animateSequence="animateSequeneOfFens"
                        :pieceSet="pieceSet"
                        :coordinatesBothSides="coordinatesBothSides"
                        @board-move="boardMove" />
          </div>

           <!-- move indicators -->
          <div v-show="(!whiteToMove && orientation=='white') || (whiteToMove && orientation=='black')" id="top_move" :style="styleTopMove" :key="!whiteToMove">
          </div>
          <div v-show="(whiteToMove && orientation=='white') || (!whiteToMove && orientation=='black')" id="bottom_move" :style="styleBottomMove" :key="whiteToMove">
          </div>

          <div :style="styleTextArea" :class="{ 'text-dark' : isDark,'text-light' : !isDark }">
                <div v-html="textareaMessage"></div>
          </div>
        </div>
        <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
      </div>
    </ion-content>
  </ion-page>

  

</template>

<script setup>

  import { IonPage, IonContent  } from '@ionic/vue';

  import CMChessboard from '@/components/CMChessboard.vue'
  import { Chess, validateFen } from 'chess.js'

  import { computed } from "@vue/reactivity"

  import { ref, watch , onMounted, onBeforeUnmount, onUnmounted } from 'vue'
  import ToolBar from '@/components/ToolBar.vue'
  import MultiOptions from '@/components/MultiOptions.vue'
  import SingleOption from '@/components/SingleOption.vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'

  import ExplainTour from '@/components/ExplainTour.vue'

  import { buildWordList, parseLichessCommands, parseComputerCommands, parsePlay, 
                    parseGameWordsSaid, processDescribe, processArrowKey }
                    from '@/composables/parsePlay.js'
  import { buildWordListFromChoiceList , matchValue, parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'
  import { buildPieceLocationStrings, getPieceSetName , columnToNumber, 
        buildAvailableMoves, buildVerbalSan} from '@/composables/blindfoldSupport.js'

  import { buildStyleToolbar, buildStyleTopline, availableWidthHeight, buildStyleMiddle,
              calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords, translatePhrase } from '@/composables/translation';

  import { useWindowSizeStore } from '../../stores/windowSizeStore';
  import TopLine from '@/components/TopLine.vue'
  import { useGetData , generateErrorAlertText } from '../../composables/getData.js'

  const emit = defineEmits(['where-next','word-list','mic-is-muted','string-to-speak'])

  const props = defineProps({
        wordsSaid : {
          type : String,
          default : ""
        },
        wordsSaidTrigger : {
          type : Number,
          default : 0
        }
      })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()

  // once we play, don't start on landing page
  connectionStore.setStartOnLandingPage("no")
  
  var friendOptions = connectionStore.getFriendOptions
  var openGame = connectionStore.getFriendOpenGame

  console.log("Friend options",friendOptions)
  const fileWords = connectionStore.getFileWords
  const languageInUse = connectionStore.getLanguageInUse

  const singleOptionWordsSpokenTrigger = ref(0)
  const multiOptionsWordsSpokenTrigger = ref(0)
  const explainTourWordsSpokenTrigger = ref(0)

  const textareaMessage = ref("")
  const coordinatesBothSides = ref(false)
  const availableMoves = ref([])
  var chess = new Chess()

  var openGameId = 0
  var canTakeBack = false
  var playingAsWhite = true
  var whiteToMove = ref(true)

  const playTitle = ref(translateEnglishWords("Play Friend"))

  const isDark = ref(connectionStore.getDarkmode != "light")
  
  const NO_GAME = 0
  const IN_GAME = 1

  var gameState = NO_GAME
  var gameResult = "*"

  const SHOW_PLAY = 0
  const SHOW_MULTIPLE_OPTIONS = 1
  const SHOW_SINGLE_OPTION = 2
  const SHOW_EXPLAINTOUR = 3

  const showState = ref(SHOW_PLAY)
  var singleOptionForEndGame = false
  var explainForState = SHOW_PLAY
  var explainForStateWordList = ""

  const TOOLBAR_BLINDFOLD_END_GAME = 0
  const TOOLBAR_BLINDFOLD_TAKEBACK = 1
  const TOOLBAR_BLINDFOLD_REVEAL = 2
  const TOOLBAR_BLINDFOLD_FLIP = 3
  const TOOLBAR_BLINDFOLD_EXPLAIN = 4

  const TOOLBAR_REGULAR_END_GAME = 20
  const TOOLBAR_REGULAR_TAKEBACK = 21
  const TOOLBAR_REGULAR_FLIP = 22
  const TOOLBAR_REGULAR_EXPLAIN = 23

  const TOOLBAR_AT_BEGINNING_START_GAME = 30
  const TOOLBAR_AT_BEGINNING_CONTINUE_GAME = 31
  const TOOLBAR_AT_BEGINNING_OPTIONS = 32
  const TOOLBAR_AT_BEGINNING_EXPLAIN = 33

  const TOOLBAR_AT_END_NEW_GAME = 40
  const TOOLBAR_AT_END_EXPORT = 41
  const TOOLBAR_AT_END_OPTIONS = 42
  const TOOLBAR_AT_END_EXPLAIN = 43

  const toolbarStartElements = [
    { index : TOOLBAR_AT_BEGINNING_START_GAME, label : translateEnglishWords("Start Game") ,disabled : false},
    { index : TOOLBAR_AT_BEGINNING_CONTINUE_GAME, label : translateEnglishWords("Continue Game") ,
                  disabled : !openGame.open},
    { index : TOOLBAR_AT_BEGINNING_OPTIONS, label : translateEnglishWords("Options") ,disabled : false},
    { index : TOOLBAR_AT_BEGINNING_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false},
  ]

  const toolbarEndElements = [
    { index : TOOLBAR_AT_END_NEW_GAME, label : translateEnglishWords("New Game") ,disabled : false},
    { index : TOOLBAR_AT_END_EXPORT, label : translateEnglishWords("Export PGN") ,disabled : false},
    { index : TOOLBAR_AT_END_OPTIONS, label : translateEnglishWords("Options") ,disabled : false},
    { index : TOOLBAR_AT_END_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false},
  ]

  const toolbarBlindfoldPlayElements = [
    { index : TOOLBAR_BLINDFOLD_END_GAME, label : translateEnglishWords("End Game") ,disabled : false},
    { index : TOOLBAR_BLINDFOLD_TAKEBACK, label : translateEnglishWords("Takeback") ,disabled : true},
    { index : TOOLBAR_BLINDFOLD_REVEAL, label : translateEnglishWords("Reveal") ,disabled : true},
    { index : TOOLBAR_BLINDFOLD_FLIP, label : translateEnglishWords("Flip") ,disabled : true},
    { index : TOOLBAR_BLINDFOLD_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false},
  ]

   const toolbarRegularPlayElements = [
    { index : TOOLBAR_REGULAR_END_GAME, label : translateEnglishWords("End Game") ,disabled : false},
    { index : TOOLBAR_REGULAR_TAKEBACK, label : translateEnglishWords("Takeback") ,disabled : false},
    { index : TOOLBAR_REGULAR_FLIP, label : translateEnglishWords("Flip") ,disabled : false},
    { index : TOOLBAR_REGULAR_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false},
  ]

  //const toolbarElements = ref((friendOptions.blindness > 1) ? toolbarBlindfoldPlayElements : toolbarRegularPlayElements)
  const toolbarElements = ref(toolbarStartElements)

  const toolbarTrigger = ref(0)
  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  const microphoneTrigger = ref(0)

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")

  const multiOptionsWordsSpoken = ref("")

  const singleOptionWordsSpoken = ref("")

  const wordlistPlay = buildWordList("friend",languageInUse)
  const wordlistExplain = "command done scroll up down"
  const wordlistTrigger = ref(0)
  const wordlist = ref(wordlistPlay)
  emit("word-list",wordlist.value)

  const explainTitle = ref("Title")
  const explainMessage = ref("Message")
    
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const TEXTAREA_FONTSIZE = 16

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  const boardSize = ref(100)
  var blankAppendTrigger = ""

  const initialFen = ref(INITIAL_FEN)
  const forceFen = ref(INITIAL_FEN)
  var fenOfCurrentBoard = INITIAL_FEN

  const animateFen = ref([])
  const animateSequeneOfFens = ref([])
  const pieceSet = ref("regular")

  var playingWhite = 1
  var orientation = ref("white")

  var playerSans = []

  var scrollCounter = 0
  const scrollTrigger = ref(0)
  const explainScrollTrigger = ref(0)

  // move replay

  var moveHistorySans = []
  var moveHistoryFens = []

  var replayHistorySans = []
  var replayHistoryFens = []
  var firstReplayMoveNumber = 1
  var fenBeforeReplay = INITIAL_FEN
  var isRevealed = false

  // OPTIONS
    
  const friendHeadings = ["Blindness Difficulty", "Color You Play", "Board Orientation","Play Keyword Required ?"]
  const friendHeadingWords = ["blindness difficulty","color","board","play"]
  const friendVarnames = ["blindness", "color", "orientation", "play_keyword"]
  
  const blindnessChoiceStrings = ["Regular Pieces","One Color Pieces","Two Color Discs","One Color Disc","Empty Board"]
  const blindnessChoiceWords = ["regular pieces piece","one color pieces piece","two color discs disc","one color discs disc","empty board"]
  const blindnessChoiceValues = [ 1, 2, 3, 4, 5 ]
  var blindnessCurrentValue = friendOptions.blindness
  var blindnessCurrentValueString = blindnessChoiceStrings[0]

  const colorChoiceStrings = ["Play as White", "Play as Black", "Random Color"]
  const colorChoiceWords = ["play as white", "play as black", "random"]
  const colorChoiceValues = [ "white", "black", "random" ]
  var colorCurrentValue = friendOptions.color
  var colorCurrentValueString = colorChoiceStrings[0]

  const playKeywordChoiceStrings =["Play Keyword Required","Piece Name Required - Including Pawn","No Play Keyword Required"]
  const playKeywordChoiceWords = ["play", "piece", "no"]
  const playKeywordChoiceValues = ["play", "piece", "no"]
  var playKeywordCurrentValue = friendOptions.playKeyword
  var playKeywordCurrentValueString = playKeywordChoiceStrings[0]

  const orientationChoiceStrings = ["Manual Flip", "Flip Board Automatically - Pass & Play", "Rotate Pieces - Playing Friend across table"]
  const orientationChoiceWords = ["manual", "flip", "rotate"]
  const orientationChoiceValues = [ "manual", "flip", "rotate" ]
  var orientationCurrentValue = friendOptions.orientation
  var orientationCurrentValueString = orientationChoiceStrings[0]

  var optionDisplay = []
  var optionDisplayWords = []
  var optionValue = []
  var optionCurrent = []
  var optionValueStrings = []

  const multipleOptionsArray = ref([])
  const singleOptionHeading = ref("")
  const singleOptionArray = ref([])
  var singleOptionDisplayWordsArray = []
  var useSingleOptionDisplayWords = ""
  var singleOptionServerField = ""
  const singleOptionSelected = ref("")

  // end OPTIONS

  const WHO_MOVE_HEIGHT = 50
  const WHO_MOVE_WIDTH = 16

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px"
  })

  const styleTopMove = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "background-color" : "steelblue"
  })

  const styleBottomMove = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "background-color" : "steelblue"
  })

  const styleTextArea = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px",
    "font-size" : TEXTAREA_FONTSIZE + "px",
    "text-align" : "center",
    "line-height" : "1.2em"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  function afterStartupCallbackRoutine(stuffChanged) {

    updateWidthHeights()
    setupUserOptions()
  }

  function updateStyleObjects(boundaries) {

    //console.log("boundaries",boundaries)
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleTopMove.value.height = boundaries['topMove'].height + "px"
    styleTopMove.value.width = boundaries['topMove'].width + "px"
    styleTopMove.value.top = boundaries['topMove'].top + "px"
    styleTopMove.value.left = boundaries['topMove'].left + "px"

    styleBottomMove.value.height = boundaries['bottomMove'].height + "px"
    styleBottomMove.value.width = boundaries['bottomMove'].width + "px"
    styleBottomMove.value.top = boundaries['bottomMove'].top + "px"
    styleBottomMove.value.left = boundaries['bottomMove'].left + "px"

    styleTextArea.value.height = boundaries['textArea'].height + "px"
    styleTextArea.value.width = boundaries['textArea'].width + "px"
    styleTextArea.value.top = boundaries['textArea'].top + "px"
    styleTextArea.value.left = boundaries['textArea'].left + "px"

    //console.log("**** boardsize ",boardSize.value,styleTextArea.value,styleBoard.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)

    styleToolbar.value = buildStyleToolbar(availableSpace)
    styleTopline.value = buildStyleTopline(availableSpace)
    styleMiddle.value = buildStyleMiddle(availableSpace)

    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
}

function calculatePortraitWidthHeights(availableSpace) {
  //console.log("available space ",availableSpace)

  const spaceForHeight = (showState.value == SHOW_PLAY) ?
                availableSpace.height - TEXTAREA_FONTSIZE * 5 * 1.2 :
                availableSpace.height /2
  // reserve space for the instruction lines
  const availableSpaceForBoard = { width : availableSpace.width - WHO_MOVE_WIDTH ,
              height : spaceForHeight - availableSpace.topIndent - 56,
              isPortrait : true }

  const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

  const boardHeight = boardDimensions.height
  const boardWidth = boardDimensions.width
  const boardPositionTop = boardDimensions.y
  const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

  const topMoveHeight = WHO_MOVE_HEIGHT
  const topMoveWidth = WHO_MOVE_WIDTH
  const topMovePositionTop = boardPositionTop
  const topMovePositionLeft = boardPositionLeft + boardWidth

  const textAreaPositionTop = boardPositionTop + boardHeight
  const textAreaPositionLeft = availableSpace.leftRightIndent
  const textAreaHeight = availableSpace.height - textAreaPositionTop
  const textAreaWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  const result = { 
    board : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft,
      top : boardPositionTop
    },
    topMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft,
      top : topMovePositionTop
    },
    bottomMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft,
      top : boardPositionTop + boardHeight - topMoveHeight
    },
    textArea : {
      width : textAreaWidth,
      height : textAreaHeight,
      left : textAreaPositionLeft,
      top : textAreaPositionTop
    }
  }
  //console.log("board and movelist dimensions",result)
  return (result)
}

function calculateLandscapeWidthHeights(availableSpace) {

  console.log("available space ",availableSpace)

  const spaceForWidth = (showState.value == SHOW_PLAY) ? availableSpace.width - 150 :
                               availableSpace.width /2
  // reserve space for the instruction lines
  const availableSpaceForBoard = { width : spaceForWidth - WHO_MOVE_WIDTH,
              height : availableSpace.height - availableSpace.topIndent - 56,
              isPortrait : false }
  const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

  const boardHeight = boardDimensions.height
  const boardWidth = boardDimensions.width
  const boardPositionTop = boardDimensions.y
  const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

  const topMoveHeight = WHO_MOVE_HEIGHT
  const topMoveWidth = WHO_MOVE_WIDTH
  const topMovePositionTop = boardPositionTop
  const topMovePositionLeft = boardPositionLeft + boardWidth

  const textAreaPositionTop = 0
  const textAreaPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent + WHO_MOVE_WIDTH
  const textAreaHeight = availableSpace.height
  const textAreaWidth = availableSpace.width - textAreaPositionLeft - WHO_MOVE_WIDTH

  const result = { board : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft,
      top : boardPositionTop
    },
     topMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft,
      top : topMovePositionTop
    },
    bottomMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft,
      top : boardPositionTop + boardHeight - topMoveHeight
    },
    textArea : {
      width : textAreaWidth,
      height : textAreaHeight,
      left : textAreaPositionLeft,
      top : textAreaPositionTop
    }
  }
  //console.log("board and movelist dimensions",result)
  return (result)
}

updateWidthHeights()

 watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** Explorer -- window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** Explorer new window size",windowSizeRef.value)
      updateWidthHeights()
    })

  const keyState = {
    ArrowUp: false,
    ArrowDown: false,
    ArrowLeft: false,
    ArrowRight: false
  }

  const handleKeyDown = (event) => {
    if (event.key in keyState) {
      keyState[event.key] = true;
      // Optional: prevent page scrolling
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
      }
      console.log("keystate",keyState)
      if (keyState.ArrowLeft) {
        const describeString = processArrowKey("left",fileWords,fenOfCurrentBoard)
        saySomething(true,describeString)
      }
      else
      if (keyState.ArrowRight) {
        const describeString = processArrowKey("right",fileWords,fenOfCurrentBoard)
        saySomething(true,describeString)
      }
      else
      if (keyState.ArrowUp) {
        const describeString = processArrowKey("up",fileWords,fenOfCurrentBoard)
        saySomething(true,describeString)
      }
      else
      if (keyState.ArrowDown) {
        const describeString = processArrowKey("down",fileWords,fenOfCurrentBoard)
        saySomething(true,describeString)
      }
    }
  };

  const handleKeyUp = (event) => {
    if (event.key in keyState) {
      keyState[event.key] = false;
    }
  };

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
  })
  
  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown);
    window.removeEventListener('keyup', handleKeyUp);
  })

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function saySomething(sayAsWhitePlayer,moveString) {
    emit('string-to-speak',sayAsWhitePlayer,moveString)
  }

  function toplineClick(whatClicked) {
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

   // START Explain Tour Routines

  function explainTourInitialize(screenPage,errorText) {
    // save which page called for an explanation
    explainForState = showState.value
    explainForStateWordList = wordlist.value

    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (errorText == null) ? screenPage : ("ERROR:" + errorText);
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)

    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_multiple",null)
        break
      case "done" :
        // restore to who ever wanted an explanation
        showState.value = explainForState
        wordlist.value = explainForStateWordList
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        break
    }
  }

  // END Explain Tour Routines

  function multiOptionsClick(index) {
    const oneOption = multipleOptionsArray.value[index]
    singleOptionHeading.value = oneOption.heading
    singleOptionArray.value = []
    singleOptionDisplayWordsArray = []
    for (var i=0; i < oneOption.displayWords.length; i++) {
      singleOptionDisplayWordsArray.push(oneOption.displayWords[i])
      const oneDisplay = {
            index : i,
            name : translateEnglishWords(oneOption.display[i]),
            words : oneOption.displayWords[i],
            id : oneOption.values[i],
            radio : "" + oneOption.values[i]
      }
      singleOptionArray.value.push(oneDisplay)
    }
    singleOptionSelected.value = "" + oneOption.current
    singleOptionServerField = oneOption.varname
    useSingleOptionDisplayWords = buildWordListFromChoiceList(singleOptionDisplayWordsArray)

    singleOptionForEndGame = false
    wordlist.value = useSingleOptionDisplayWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    showState.value = SHOW_SINGLE_OPTION
  }

  function multiOptionsToolbarClick(selected) {
    toolbarTrigger.value++
    switch (selected) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_multiple",null)
        break
      case "done" :
        setupUserOptions()
        switchToPlay()
        break
    }
  }

  function singleOptionClick(index) {
    const databaseValue = singleOptionArray.value[index].radio
    singleOptionSelected.value = singleOptionArray.value[index].radio
    if (singleOptionForEndGame == false) {
      setOption(singleOptionServerField,databaseValue)
    }
  }

  function singleOptionToolbarClick(selected) {
    toolbarTrigger.value++
    switch (selected) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "explain" :
        explainTourInitialize("options_single",null)
        break
      case "done" :
        if (singleOptionForEndGame) {
          console.log("END GAME RESPONSE",singleOptionSelected.value)
          if (singleOptionSelected.value != "no") {
            console.log("**** END GAME")
            setEndGame(singleOptionSelected.value)
          }
          else {
            console.log("**** NO END GAME")
          }
          switchToPlay()
        }
        else
          buildMultipleOptionsDisplay()
        break
    }
  }

  function getAvailableMoves(fen) {
    var fenPieces = fen.split(" ")
    fenPieces[5] = 1
    const fenFixed = fenPieces.join(" ")
    chess.load(fenFixed)
    const moves = chess.moves({ verbose: true })
    availableMoves.value = buildAvailableMoves(moves,false)
  }

  function updateGame(isOpen,result) {
    openGame = {
        sans : moveHistorySans,
        fens: moveHistoryFens,
        friendOptions : friendOptions,
        open : isOpen,
        playingAsWhite : playingAsWhite,
        result : result
    }
    connectionStore.setFriendOpenGame(openGame)
  }

  function boardMove(arrayIndex,from,to) {
    const oneMove = availableMoves.value[arrayIndex]

    forceFen.value = oneMove.fen
    fenOfCurrentBoard = oneMove.fen
    
    const speakString = buildVerbalSan(oneMove.chessJS,fileWords)
    saySomething(whiteToMove.value,speakString)

    moveHistoryFens.push(oneMove.fen)
    moveHistorySans.push(oneMove.san)

    updateGame(true,"*")

    const replayString = buildReplayHistory()
    
    textareaMessage.value = (whiteToMove.value) ? translateEnglishWords("White") : translateEnglishWords("Black")

    textareaMessage.value += " " + translateEnglishWords("Move") + " : " + oneMove.san + "<br>" + replayString

    canTakeBack = true

    if (friendOptions.blindness >= 2) {
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_TAKEBACK,false)
    }
    else {
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REGULAR_TAKEBACK,false)
    }
    toolbarTrigger.value++

    getAvailableMoves(oneMove.fen)
    whiteToMove.value = !whiteToMove.value

    if (friendOptions.orientation == "flip") {
      let timerSleepAmount = 750
      function oneInterval() {
        clearInterval(id)
        orientation.value = (whiteToMove.value) ? "white" : "black"
      }
      var id = setInterval(oneInterval, timerSleepAmount)
    }

    // give a 1/2 second before rotating the pieces
    if (friendOptions.orientation == "rotate" && friendOptions.blindness <= 2) {
      let timerSleepAmount = 500
      function oneInterval() {
        clearInterval(id)
        // toolbarElements.value[TOOLBAR_TAKEBACK].disabled = true
        // toolbarTrigger.value++
        setPieces((playingAsWhite == whiteToMove.value) ? friendOptions.blindness : friendOptions.blindness + 10)
      }
      var id = setInterval(oneInterval, timerSleepAmount)
    }
  }

  function switchToPlay() {
    showState.value = SHOW_PLAY
    wordlist.value = wordlistPlay
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    toolbarTrigger.value++
  }
 
  function toolbarClick(arrayIndex) {
    console.log("toolbar click",arrayIndex)
    var useIndex = arrayIndex

    switch (useIndex) {
      case TOOLBAR_AT_BEGINNING_START_GAME :
      case TOOLBAR_AT_END_NEW_GAME :
        processWords("command start game")
        break
      case TOOLBAR_AT_BEGINNING_CONTINUE_GAME :
        processWords("command continue game")
        break
      case TOOLBAR_AT_END_EXPORT :
        console.log("EXPORT GAME")
        buildExportPGN()
        break
      case TOOLBAR_AT_END_OPTIONS :
      case TOOLBAR_AT_BEGINNING_OPTIONS :
        processWords("command options")
        break
      case TOOLBAR_BLINDFOLD_FLIP :
      case TOOLBAR_REGULAR_FLIP :
        if (friendOptions.orientation == "manual")
          orientation.value = (orientation.value == "white") ? "black" : "white"
        break
      case TOOLBAR_BLINDFOLD_TAKEBACK :
      case TOOLBAR_REGULAR_TAKEBACK :
        if (gameState == IN_GAME)
          processWords("command take back")
        break
      case TOOLBAR_BLINDFOLD_REVEAL :
        processWords("command reveal");
        break
      case TOOLBAR_AT_END_EXPLAIN :
      case TOOLBAR_AT_BEGINNING_EXPLAIN :
      case TOOLBAR_BLINDFOLD_EXPLAIN :
      case TOOLBAR_REGULAR_EXPLAIN :
        processWords("command explain")
        break;
      case TOOLBAR_BLINDFOLD_END_GAME :
      case TOOLBAR_REGULAR_END_GAME :
        processWords("command end game")
        break
    }
  }

  function wrapText(str, width = 80) {
    // Replace multiple blanks/whitespaces with a single space first if needed
    const normalized = str.replace(/\s+/g, ' ').trim();
    
    // Use a regex to find the last space before the 80-character mark
    const regex = new RegExp(`(.{1,${width}})( +|$)`, 'g');
    return normalized.match(regex).map(line => line.trim()).join('\n');
  }

  async function shareFile(fileContent, fileName = 'analysis.pgn') {
  
    const file = new File([fileContent], fileName, { type: 'text/plain' });

    // 2. Check if the browser supports sharing files
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({
          files: [file],
          title: 'Chess Game Analysis',
          text: 'PGN or HTML exported from ChessvisAI Analyzer',
        });
        return 'shared';
      } catch (error) {
        // If user cancels the share, we don't necessarily want to trigger a download
        if (error.name === 'AbortError') return 'cancelled';
        console.error('Share failed, falling back to download', error);
      }
    }

    // 3. Fallback: Desktop Download
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a); // Required for some Firefox versions
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return 'downloaded';
  }

  function buildExportPGN() {

    console.log("GAME IN EXPORT",openGame)
    const date = new Date();
    const formattedDate = new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(date).replace(/-/g, '.');

    // build fake tags
    var tags = [
      '[Event "Verbal Chess Play Friend"]',
      '[Site "Verbal Chess Play Friend"]',
      '[Date "' + formattedDate + '"]',
      '[Round "?"]',
      '[White "?"]',
      '[Black "?"]'
    ]

    // build the moves
    var moveStrings = []
    var moveNumber = 0
    for (var i=0; i < openGame.sans.length; i++) {
      if (i % 2 == 0) {
        moveNumber++
        moveStrings.push(moveNumber + ".")
      }
      moveStrings.push(openGame.sans[i])
    }

    // add result
    switch (gameResult) {
      case "white" :
        moveStrings.push("1-0")
        tags.push('[Result "1-0"]')
        break
       case "black" :
        moveStrings.push("0-1")
        tags.push('[Result "0-1"]')
        break
      case "draw" :
        moveStrings.push("1/2-1/2")
        tags.push('[Result "1/2-1/2"]')
        break
      default :
        moveStrings.push("*")
        tags.push('[Result "*"]')
        break
    }
    const moveText = moveStrings.join(" ")
    const shortLines = wrapText(moveText)

    const pgn = tags.join("\n") + "\n\n" + shortLines + "\n\n"
    //console.log("PGN",pgn)
    shareFile(pgn,"verbal_chess_play_friend_" + formattedDate + ".pgn")
  }

  function verifyEndGame() {
    singleOptionHeading.value = translatePhrase("End Game?")
    singleOptionArray.value = []
    singleOptionDisplayWordsArray = []
    singleOptionDisplayWordsArray.push("no")
    singleOptionDisplayWordsArray.push("white")
    singleOptionDisplayWordsArray.push("black")
    singleOptionDisplayWordsArray.push("draw")
    singleOptionDisplayWordsArray.push("continue")
    singleOptionDisplayWordsArray.push("just")
  
    singleOptionArray.value = [
      { index : 0, name : translateEnglishWords("No end"), id : 0,radio : "no" , words : "no"},
      { index : 1, name : translateEnglishWords("White Wins"), id : 1,radio : "white" , words : "white"},
      { index : 2, name : translateEnglishWords("Black Wins"), id : 2,radio : "black" , words : "black"},
      { index : 3, name : translateEnglishWords("Draw"), id : 3,radio : "draw" , words : "draw"},
      { index : 4, name : translateEnglishWords("Continue later"), id : 4,radio : "continue" , words : "continue"},
      { index : 5, name : translateEnglishWords("Just end"), id : 5,radio : "just" , words : "just"},
    ]

    singleOptionSelected.value = "draw"
    singleOptionServerField = ""
    useSingleOptionDisplayWords = buildWordListFromChoiceList(singleOptionDisplayWordsArray)
    //console.log("****************** single option array",singleOptionArray.value)
    //console.log("****************** single option word list",useSingleOptionDisplayWords)

    singleOptionForEndGame = true
    wordlist.value = useSingleOptionDisplayWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    showState.value = SHOW_SINGLE_OPTION
  }
  
  function processWordsForPlay(text) {
    const returnArray = parseGameWordsSaid(text,gameState == IN_GAME,false,availableMoves,
                    friendOptions.playKeyword)
    console.log("raw speech text",text)
    console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "ambiguous" :
        textareaMessage.value = returnArray[1]
        saySomething(true,returnArray[2])
        break;
      case "play" :
        if (showState.value == SHOW_PLAY) {
          const arrayIndex = returnArray[1]
          boardMove(arrayIndex,0,0)
        }
        break
      case "describe" :
        const describeString = processDescribe(returnArray[1],returnArray[2],returnArray[3],returnArray[4], 
                returnArray[5],returnArray[6],fileWords,fenOfCurrentBoard)
        saySomething(true,describeString)
        break
      case "command" :
        switch (returnArray[1]) {
          case "start game" :
            if (gameState == NO_GAME)
              startGame()
            break
          case "end game" :
            if (gameState == IN_GAME)
              verifyEndGame()
            break
          case "export" :
            if (gameState != IN_GAME)
              buildExportPGN()
            break
          case "continue game" :
            console.log("continue",gameState,openGame)
            if (gameState == NO_GAME && openGame.open)
              continueGame()
            break
          case "takeback" :
            if (gameState == IN_GAME && canTakeBack) {
              handleMoveTakeBack()
            }
            break  
          case "flip" :
            if (friendOptions.orientation == "manual")
              orientation.value = (orientation.value == "white") ? "black" : "white"
            break
          case "reveal" :
          case "revert" :
            if (gameState == IN_GAME && friendOptions.blindness >= 2) {              
              if (friendOptions.orientation == "rotate") {
                if (!isRevealed)
                  setPieces((playingAsWhite == whiteToMove.value) ? 1 : 11)
                else
                  setPieces((playingAsWhite == whiteToMove.value) ? friendOptions.blindness : friendOptions.blindness + 10)
              }
              else
                setPieces((isRevealed) ? 1 : friendOptions.blindness)
              //forceFen.value += " "
              isRevealed = !isRevealed
              toolbarElements.value[TOOLBAR_BLINDFOLD_REVEAL].label = (isRevealed) ? translateEnglishWords("Revert") : 
                                    translateEnglishWords("Reveal")
              toolbarTrigger.value++
            }
            break
          case "options" :
            if (showState.value == SHOW_PLAY && gameState == NO_GAME)
              buildMultipleOptionsDisplay()
            break
          case "explain" :
            explainTourInitialize("verbalplay",null)
            break;
          case "mute" :
            microphoneIsMuted.value = true 
            emit("mic-is-muted",microphoneIsMuted.value)
            connectionStore.setMicrophoneIsMuted(true)
            break
          case "listen" :
            microphoneIsMuted.value = false 
            emit("mic-is-muted",microphoneIsMuted.value)
            connectionStore.setMicrophoneIsMuted(false)
            break
          case "done" :
            emit("where-next","/enginemenu")
            break;
        }
        break
    }
  }

  function processWords(text) {
    //console.log("text and state",showState.value)
    switch (showState.value) {
      case SHOW_EXPLAINTOUR :
        explainTourWordsSpoken.value = text
        explainTourWordsSpokenTrigger.value++
        break
      case SHOW_MULTIPLE_OPTIONS :
        multiOptionsWordsSpoken.value = text
        multiOptionsWordsSpokenTrigger.value++
        break
      case SHOW_SINGLE_OPTION :
        singleOptionWordsSpoken.value = text
        singleOptionWordsSpokenTrigger.value++
        break
      case SHOW_PLAY :
        processWordsForPlay(text)
        break
    }
  }
    
  function buildReplayHistory() {
    var isWhiteMove = true
    var replayString = ""
    var firstIndex = 0
    var moveCounter = 0
    replayHistorySans = []
    replayHistoryFens = []
    firstReplayMoveNumber = 1
    fenBeforeReplay = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
    
    if (moveHistorySans.length > 10) {
        if (moveHistorySans.length % 2 == 1) {
            firstIndex = moveHistorySans.length - 11
            firstReplayMoveNumber = firstIndex / 2 + 1
        }
        else {
            firstIndex = moveHistorySans.length - 10
            firstReplayMoveNumber = firstIndex / 2 + 1
        }
    }
    
    if (firstIndex > 0) {
        fenBeforeReplay = moveHistoryFens[firstIndex-1]
    }
    replayHistoryFens.push(fenBeforeReplay)
    moveCounter = firstReplayMoveNumber
    for (var i = firstIndex; i < moveHistorySans.length; i++) {
        if (isWhiteMove) {
            if (i != firstIndex) {
                replayString += " "
            }
            replayString += String(moveCounter) + "."
            moveCounter += 1
        }
        replayString += " " + moveHistorySans[i]
        replayHistoryFens.push(moveHistoryFens[i])
        replayHistorySans.push(moveHistorySans[i])
        
        isWhiteMove = !isWhiteMove
    }
    return (replayString)
  }
  
  function buildFirstMoveNote() {

    var firstMoveNote1 = ""
    var firstMoveNote2 = ""
    switch (friendOptions.playKeyword) {
      case "no" :
        firstMoveNote1 = translatePhrase("No Play Keyword Required")
        firstMoveNote2 = translatePhrase("Just say e4 or echo 4")
        break;
      case "piece" :
        firstMoveNote1 = translatePhrase("Say piece name even if pawn")
        firstMoveNote2 = translatePhrase("Pawn e4 or Pawn echo 4")
        break;
      default :
        firstMoveNote1 = translatePhrase("Play Keyword Required")
        firstMoveNote2 = translatePhrase("Say 'play e4' or 'play echo 4'")
        break;
    }
    const firstMoveNote3 = translateEnglishWords("Piece Names : rook knight bishop queen king pawn")
    return ("<br>" + firstMoveNote1 + "<br>" + firstMoveNote2 + "<br>" + firstMoveNote3)
  }

  function handleMoveTakeBack() {
    var fen = INITIAL_FEN
    if (moveHistoryFens.length == 0)
      return

    canTakeBack = false
    moveHistoryFens.pop()
    moveHistorySans.pop()

    updateGame(true,"*")

    if (moveHistoryFens.length > 0)
      fen = moveHistoryFens[moveHistoryFens.length - 1]
    getAvailableMoves(fen)
    whiteToMove.value = !whiteToMove.value
    forceFen.value = fen
    fenOfCurrentBoard = fen

    let replayString = buildReplayHistory()

    var stringToSay = (whiteToMove.value) ? translateEnglishWords("White") : translateEnglishWords("Black")
    stringToSay += " " + translateEnglishWords("move taken back")

    saySomething(whiteToMove.value,stringToSay)
    textareaMessage.value = stringToSay + "<br>" + replayString

    if (friendOptions.orientation == "rotate")
      if (friendOptions.blindness == 1 || friendOptions.blindness == 2)
        setPieces((playingAsWhite == whiteToMove.value) ? friendOptions.blindness : friendOptions.blindness + 10)
  
    if (friendOptions.blindness >= 2) {
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_TAKEBACK,true)
    }
    else {
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REGULAR_TAKEBACK,true)
    }
    toolbarTrigger.value++

    if (friendOptions.orientation == "flip")
      orientation.value = (whiteToMove.value) ? "white" : "black"
  
  }

  function getArrayIndexFromValueMatch(choiceValues,current) {
    for (var i=0; i < choiceValues.length; i++)
      if (current == choiceValues[i])
        return (i)
    return (0)
  }

  function setupUserOptions() {

    console.log("In setup user options",friendOptions)
    blindnessCurrentValue = friendOptions.blindness
    colorCurrentValue = friendOptions.color
    playKeywordCurrentValue = friendOptions.playKeyword
    orientationCurrentValue = friendOptions.orientation

    const blindnessIndex = getArrayIndexFromValueMatch(blindnessChoiceValues,blindnessCurrentValue)
    const colorIndex = getArrayIndexFromValueMatch(colorChoiceValues,colorCurrentValue)
    const playKeywordIndex = getArrayIndexFromValueMatch(playKeywordChoiceValues,playKeywordCurrentValue)
    const orientationIndex = getArrayIndexFromValueMatch(orientationChoiceValues,orientationCurrentValue)

    blindnessCurrentValueString = translatePhrase(blindnessChoiceStrings[blindnessIndex])
    colorCurrentValueString = translatePhrase(colorChoiceStrings[colorIndex])
    playKeywordCurrentValueString = translatePhrase(playKeywordChoiceStrings[playKeywordIndex])
    orientationCurrentValueString = translatePhrase(orientationChoiceStrings[orientationIndex])
    
    textareaMessage.value = blindnessCurrentValueString + "<br>" + colorCurrentValueString + "<br>" + 
            orientationCurrentValueString + "<br>" +playKeywordCurrentValueString

    coordinatesBothSides.value = friendOptions.orientation == "rotate"
    console.log("coordinatesBothSides",coordinatesBothSides.value)
    incrementAppendTrigger()
    forceFen.value = INITIAL_FEN + blankAppendTrigger
  }

  function setPieces(blindnessLevel) {
    console.log("SET PIECES",blindnessLevel)
    switch (blindnessLevel) {
      case 10 :
      case 11 : 
        pieceSet.value = "regular_rotated"
        break
      case 12 : 
        pieceSet.value = "one_color_rotated"
        break
      case 0 :
      case 1 :
        pieceSet.value = "regular"
        break
      case 12 :
      case 2 : 
        pieceSet.value = "one_color"
        break
      case 13:
      case 3 :
        pieceSet.value = "two_disks"
        break
      case 14 :
      case 4 :
        pieceSet.value = "one_disk"
        break
      case 15:
      case 5 :
        pieceSet.value = "invisible"
        break
    }
  }

  function continueGame() {

    gameState = IN_GAME
    gameResult = "*"

    moveHistorySans = JSON.parse(JSON.stringify(openGame.sans))
    moveHistoryFens = JSON.parse(JSON.stringify(openGame.fens))
    whiteToMove.value = (moveHistorySans.length % 2) == 0

    playingAsWhite = openGame.playingAsWhite
    friendOptions = openGame.friendOptions

    if (playingAsWhite) {
      orientation.value = "white"
      setPieces(friendOptions.blindness)
    }
    else {
      orientation.value = "black"

      // if playing friend across the table, they play white so rotate
      if (friendOptions.orientation == "rotate" && whiteToMove.value) {
        setPieces(friendOptions.blindness + 10)
      }
      else 
        setPieces(friendOptions.blindness)
    }

    incrementAppendTrigger()
    const fen = (moveHistorySans.length > 0) ? moveHistoryFens[moveHistoryFens.length - 1] :
                  INITIAL_FEN
    forceFen.value = fen + blankAppendTrigger

    getAvailableMoves(fen)    
    const firstMoveNote = buildFirstMoveNote()

    var sayString = (whiteToMove.value) ? translateEnglishWords("White") : translateEnglishWords("Black")
    sayString += " " + translateEnglishWords("Make Move")
    saySomething(whiteToMove.value,sayString)
    textareaMessage.value = sayString + "<br>" + firstMoveNote

    canTakeBack = false

    if (friendOptions.blindness >= 2) {
      toolbarElements.value = toolbarBlindfoldPlayElements
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_TAKEBACK,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_REVEAL,false)
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_BLINDFOLD_REVEAL,translateEnglishWords("Reveal"))
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_FLIP,
              friendOptions.orientation != "manual")
    }
    else {
      toolbarElements.value = toolbarRegularPlayElements
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REGULAR_TAKEBACK,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REGULAR_FLIP,
              friendOptions.orientation != "manual")
    }
    toolbarTrigger.value++

    isRevealed = false

  }

  function startGame() {

    gameState = IN_GAME
    gameResult = "*"

    whiteToMove.value = true
    switch (friendOptions.color) {
      default :
      case "white" :
        playingAsWhite = true
        break
      case "black" :
        playingAsWhite = false
        break
      case "random" :
        playingAsWhite = (Math.random() < .5)
        break
    }

    console.log("friendoptions",friendOptions)

    if (playingAsWhite) {
      orientation.value = "white"
      setPieces(friendOptions.blindness)
    }
    else {
      orientation.value = "black"

      // if playing friend across the table, they play white so rotate
      if (friendOptions.orientation == "rotate") {
        setPieces(friendOptions.blindness + 10)
      }
      else 
        setPieces(friendOptions.blindness)
    }

    incrementAppendTrigger()
    forceFen.value = INITIAL_FEN + blankAppendTrigger

    getAvailableMoves(INITIAL_FEN)    
    const firstMoveNote = buildFirstMoveNote()
    saySomething(false,translateEnglishWords("White Make Move"))
    textareaMessage.value = translateEnglishWords("White Make Move") + "<br>" + firstMoveNote

    canTakeBack = false

    if (friendOptions.blindness >= 2) {
      toolbarElements.value = toolbarBlindfoldPlayElements
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_TAKEBACK,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_REVEAL,false)
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_BLINDFOLD_REVEAL,translateEnglishWords("Reveal"))
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BLINDFOLD_FLIP,
              friendOptions.orientation != "manual")
    }
    else {
      toolbarElements.value = toolbarRegularPlayElements
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REGULAR_TAKEBACK,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REGULAR_FLIP,
              friendOptions.orientation != "manual")
    }
    toolbarTrigger.value++

    isRevealed = false

    moveHistorySans = []
    moveHistoryFens = []

  }

  function buildMultipleOptionsDisplay() {

    optionDisplay = [ blindnessChoiceStrings,colorChoiceStrings,orientationChoiceStrings,playKeywordChoiceStrings]
    optionDisplayWords = [ blindnessChoiceWords,colorChoiceWords,orientationChoiceWords,playKeywordChoiceWords]
    optionValue = [ blindnessChoiceValues,colorChoiceValues,orientationChoiceValues,playKeywordChoiceValues]
    optionCurrent = [blindnessCurrentValue,colorCurrentValue,orientationCurrentValue,playKeywordCurrentValue]
    optionValueStrings = [blindnessCurrentValueString,colorCurrentValueString,orientationCurrentValueString,playKeywordCurrentValueString]
   
    multipleOptionsArray.value = []
    for (var i = 0; i < optionDisplay.length; i++) {
      const oneOption = {
          index : i,
          heading : translateEnglishWords(friendHeadings[i]),
          headingWords : friendHeadingWords[i],
          varname : friendVarnames[i],
          display : optionDisplay[i],
          displayWords : optionDisplayWords[i],
          values : optionValue[i],
          current : optionCurrent[i],
          currentString : optionValueStrings[i]
      }
      multipleOptionsArray.value.push(oneOption)
    }
    //console.log("options",multipleOptionsArray.value)

    wordlist.value = buildWordListFromChoiceList(friendHeadingWords)
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
    showState.value = SHOW_MULTIPLE_OPTIONS    
  }

  function setOption(fieldName,value) {
    console.log("SET OPTIONS",fieldName,value)
    switch (fieldName) {
      case "blindness" :
        friendOptions.blindness = parseInt(value)
        toolbarElements.value = (friendOptions.blindness > 1) ? toolbarBlindfoldPlayElements : toolbarRegularPlayElements
        break
      case "color" :
        friendOptions.color = value
        break
      case "play_keyword" :
        friendOptions.playKeyword = value
        break
      case "orientation" :
        friendOptions.orientation = value
        break
    }
    connectionStore.setFriendOptions(friendOptions)
    setupUserOptions()

  }

  function processSetEndGameJsonResponse (json) {
    //console.log(" in set end game callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize(null,generateErrorAlertText(json))
      return;
    }

    xyz
    toolbarElements.value[TOOLBAR_END_GAME].label = translateEnglishWords("New Game")
    toolbarElements.value[TOOLBAR_TAKEBACK_OPTIONS].label = translateEnglishWords("Options")
    toolbarElements.value[TOOLBAR_TAKEBACK_OPTIONS].disabled = false

    toolbarElements.value[TOOLBAR_REPLAY_REVIEW].label = translateEnglishWords("Review")
    toolbarElements.value[TOOLBAR_REPLAY_REVIEW].disabled = false

    if (friendOptions.blindness >= 2) {
      toolbarElements.value[TOOLBAR_BLINDFOLD_REVEAL].disabled = true
    }

    toolbarTrigger.value++

    connectionStore.setPlayComputerGameId("0")
    gameState = NO_GAME
    availableMoves.value = []
  }

  function setEndGame(endResult) {

    if (endResult == "continue") {
      textareaMessage.value = translateEnglishWords("Continue Game Later")
      updateGame(true,"*")
      gameResult = "*"
    }
    else {
      textareaMessage.value = translateEnglishWords("Game Over")
      updateGame(false,endResult)
      gameResult = endResult
    }

    gameState = NO_GAME
    availableMoves.value = []

    toolbarElements.value = toolbarEndElements
    toolbarTrigger.value++
  }

</script>

<style scoped>


</style>
